export default __webpack_public_path__ + "static/media/emailme.a60657eb.svg";